export var setSlider = function (_a) {
    var slider = _a.slider, wrapper = _a.wrapper, offset = _a.offset, _b = _a.className, className = _b === void 0 ? 'wp-block-vape-shop-slider' : _b;
    var buttons = slider.querySelectorAll(".".concat(className, "__button"));
    var checkShowButton = function (x) {
        if (x === void 0) { x = 0; }
        buttons.forEach(function (button) {
            if (button.classList.contains('left')) {
                wrapper.scrollLeft + x <= 0
                    ? button.classList.add('hidden')
                    : button.classList.remove('hidden');
            }
            else {
                wrapper.scrollWidth <= wrapper.scrollLeft + wrapper.clientWidth + x
                    ? button.classList.add('hidden')
                    : button.classList.remove('hidden');
            }
        });
    };
    if (buttons.length > 0) {
        buttons.forEach(function (button) {
            button.addEventListener('click', function () {
                if (button.classList.contains('left')) {
                    wrapper.scrollLeft -= offset;
                    checkShowButton(-offset);
                }
                else {
                    wrapper.scrollLeft += offset;
                    checkShowButton(offset);
                }
            });
        });
    }
    return { checkShowButton: checkShowButton };
};
